module.exports = __webpack_public_path__ + "media/images/solutions-forms-triplet-3-911e0569819ac42a589d03cdf1c34c6e.svg";